import React from 'react';
import { Link } from 'react-router-dom';
import { entityUrlFromRoute } from '@/constants/urls';
import { allowResourceLink } from '../helper';

const AuditResourceLink = ({
  allowCohortLink,
  allowCollectionLink,
  allowDatasetLink,
  allowRequestLink,
  allowRoleLink,
  allowSearchLink,
  allowUserGroupLink,
  allowUserLink,
  entity,
  name,
  route,
}) => (
  <>
    {allowResourceLink(
      entity,
      allowRoleLink,
      allowUserLink,
      allowDatasetLink,
      allowSearchLink,
      allowRequestLink,
      allowCohortLink,
      allowCollectionLink,
      allowUserGroupLink,
    ) && (<Link to={entityUrlFromRoute(entity, route)} title={name}>{name}</Link>)}
    {!allowResourceLink(
      entity,
      allowRoleLink,
      allowUserLink,
      allowDatasetLink,
      allowSearchLink,
      allowRequestLink,
      allowCohortLink,
      allowCollectionLink,
      allowUserGroupLink,
    ) && (name)}
  </>
);

export default AuditResourceLink;
